import { clsx } from "@/utils";
import { Typography } from "../Typography/Typography";

export interface ImageSelectItemProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  src?: string;
  icon?: JSX.Element;
  selected?: boolean;
}

export const ImageSelectItem = ({ label, src, icon, selected, className, ...props }: ImageSelectItemProps) => {
  const renderImage = () => {
    if (src) return <img src={src} alt={label} className="h-[48px] w-[48px] select-none md:h-[64px] md:w-[64px]" />;
    if (icon) return icon;
  };

  return (
    <div
      className={clsx(
        "flex h-[186px] w-[138px] cursor-pointer items-center justify-center rounded-lg border border-neutral-surface-gray bg-neutral-surface-gray p-1.5 transition-colors ease-linear hover:border-primary-dark hover:bg-primary-light md:w-[184px] md:p-4",
        { "border-primary-dark bg-primary-light": selected },
        className
      )}
      {...props}
    >
      <div className="flex flex-col items-center justify-center gap-y-3.5">
        {renderImage()}
        <Typography variant="paragraph" className="text-center">
          {label}
        </Typography>
      </div>
    </div>
  );
};

ImageSelectItem.displayName = "ImageSelectItem";
